import * as React from "react";

import { Control, Errors } from "react-redux-form";
import {
  updateOn,
  validateOn,
  mapProps,
  showErrors
} from "./ReactReduxFormSettings";
import ValidationMessage from "./ValidationMessage";
import { requiredBool } from "../../../Common/validators";

export interface CheckboxControlProps {
  mandatory: boolean;
  model: string;
  readOnly?: boolean;
}

class CheckboxControl extends React.PureComponent<any, any> {
  render() {
    return (
      <div>
        <Control.checkbox
          model={this.props.model}
          placeholder=""
          validators={{
            required: this.props.mandatory ? requiredBool : () => true
          }}
          updateOn={updateOn}
          validateOn={validateOn}
          mapProps={mapProps}
          controlProps={{
            label: "",
            validate: true
          }}
          readOnly={this.props.readOnly}
        />
        <Errors
          model={this.props.model}
          messages={{
            required: "Please tick the box"
          }}
          show={showErrors}
          component={ValidationMessage}
        />
      </div>
    );
  }
}

export default CheckboxControl;
